export const checkRequiresUpgrade = () => {
  var features = {
    flexbox: ['flex-wrap', '-webkit-flex-wrap'],
    transform: ['transform', '-webkit-transform', '-ms-transform']
  };

  var _isStyleSupported = function(el, property) {
    return el.style[property] !== undefined;
  };

  var needsUpgrade = false;
  var testEl = document.createElement('div');
  var hasFeature = false;
  for (var feature in features) {
    if (features.hasOwnProperty(feature)) {
      for (var property in features[feature]) {
        if (features[feature].hasOwnProperty(property)) {
          hasFeature = _isStyleSupported(testEl, features[feature][property]);
          if (hasFeature) {
            needsUpgrade = false;
            break;
          }
        }
      }
      if (!hasFeature) {
        needsUpgrade = true;
        return;
      }
    }
  }
  return needsUpgrade;
};

const template = `
<div class="update-browser-content">
  <div class="brand-logo">
    <img
        src="http://www.gmc.com/content/dam/GMC/global/master/nscwebsite/en/home/Homepage/01_images/GMC_Logo_93x40.png"/>
  </div>
  <h1 class="headline">Your browser version is outdated and no longer supported.
  </h1>

  <p class="details">
    Please update to the latest version of your preferred browser.
  </p>

  <p class="details">
    Updating your browser will improve your speed, provide the latest security and privacy features, and improve
    your overall experience across all the sites you visit.
  </p>

  <h2 class="subheadline">
    Select one of the icons below to update your browser.
  </h2>

  <div class="browsers">
    <a href="https://www.google.com/chrome/browser/desktop/" class="browser">
      <div class="chrome browser-logo"></div>
      <p>Chrome</p>
    </a>

    <a href="https://www.mozilla.org/en-US/firefox/new/" class="browser">
      <div class="firefox browser-logo"></div>
      <p>Firefox</p>
    </a>

    <a href="http://windows.microsoft.com/en-us/internet-explorer/download-ie" class="browser">
      <div class="ie browser-logo"></div>
      <p>Internet Explorer</p>
    </a>

    <a href="http://www.apple.com/safari/" class="browser">
      <div class="safari browser-logo"></div>
      <p>Safari</p>
    </a>

  </div>
</div>
`;

export const renderUpgrade = el => {
  el.innerHTML = template;
};
